import React, { useState as _useState, useEffect as _useEffect } from 'react'
import Imitation from '@/components/Compare/Imitation'
import { useAppDispatch as _useAppDispatch, useAppSelector as _useAppSelector } from '@/hooks'
import {
  getCompareImgsInfoByImgID as _getCompareImgsInfoByImgID,
  getCompareSimilarImgs as _getCompareSimilarImgs
} from '@/server/index'
import './index.less'

interface _similarImgsI {
  uuid: string
  sim: number
}
export interface similarImgsInfoI {
  title: string
  similarity: number
  author: string
  imgSrc: string
  dynasty: string
}

export default function ImitationCompare(props) {
  // const dispatch = useAppDispatch()
  // const imageId = useAppSelector((state) => state.analysisImageInfo.imageId)
  // const [similarImgs, setSimilarImgs] = useState<similarImgsI[]>([])
  // const [similarImgsInfo, setSimilarImgsInfo] = useState<similarImgsInfoI[]>([])
  // //点入传移模写界面时发送得到相似图像的请求
  // useEffect(() => {
  //   getCompareSimilarImgs({
  //     uuid: imageId
  //   }).then((res) => {
  //     if (res.data.content !== null) {
  //       const newSimilarImgs: similarImgsI[] = []
  //       res.data.content.map((item) => {
  //         newSimilarImgs.push({
  //           uuid: item.uuid2,
  //           sim: item.sim
  //         })
  //       })
  //       setSimilarImgs(newSimilarImgs)
  //     }
  //   })
  // }, [dispatch, imageId])
  // useEffect(() => {
  //   //similarImgs改变时发送请求，获取图像具体信息
  //   const dataArr: Promise<any>[] = []
  //   for (let i = 0; i < similarImgs.length; i++) {
  //     if (i >= 20) break
  //     dataArr.push(
  //       getCompareImgsInfoByImgID({
  //         imageId: similarImgs[i].uuid
  //       })
  //     )
  //   }
  //   const newSimilarImgsInfo: similarImgsInfoI[] = []
  //   Promise.all(dataArr).then((values) => {
  //     for (let i = 0; i < values.length; i++) {
  //       let currentSimilarImgInfo: similarImgsInfoI = {
  //         title: values[i].data.content.workname,
  //         similarity: Number(similarImgs[i].sim.toFixed(2)) * 100,
  //         author: values[i].data.content.authorname,
  //         imgSrc: values[i].data.content.encoding,
  //         dynasty: values[i].data.content.dynasty
  //       }
  //       newSimilarImgsInfo.push(currentSimilarImgInfo)
  //     }
  //     setSimilarImgsInfo(newSimilarImgsInfo)
  //   })
  // }, [similarImgs])
  const { similarImgsInfo } = props
  return (
    <div className='compare-imitation'>
      <Imitation similarImgsInfo={similarImgsInfo} />
    </div>
  )
}
